/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_North_America_DescriptionInputs */

const bn_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উত্তর আমেরিকার সব দেশ একক পুলে।`)
};

const de_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle nordamerikanischen Länder in einem einzigen Pool.`)
};

const el_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Όλες οι χώρες της Βόρειας Αμερικής σε μια ενιαία πισίνα.`)
};

const en_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All North American countries in a single pool.`)
};

const es_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los países de Norteamérica en un solo pool.`)
};

const fr_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les pays d’Amérique du Nord dans un seul pool.`)
};

const hi_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी उत्तरी अमेरिकी देश एक ही पूल में।`)
};

const hu_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az összes észak-amerikai ország egyetlen medencében.`)
};

const id_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua negara Amerika Utara dalam satu kelompok.`)
};

const it_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i paesi del Nord America in un unico pool.`)
};

const ja_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単一のプール内のすべての北米諸国。`)
};

const ko_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 북미 국가가 단일 풀에 있습니다.`)
};

const nl_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Noord-Amerikaanse landen in één pool.`)
};

const pl_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie kraje Ameryki Północnej w jednej puli.`)
};

const pt_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os países da América do Norte em um único grupo.`)
};

const ru_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все страны Северной Америки в одном пуле.`)
};

const sv_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla nordamerikanska länder i en enda pool.`)
};

const tr_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Kuzey Amerika ülkeleri tek bir havuzda.`)
};

const uk_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі країни Північної Америки в одному пулі.`)
};

const vi_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả các nước Bắc Mỹ trong một nhóm duy nhất.`)
};

const zh_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有北美国家都在一个池中。`)
};

const zh_hant_intro_region_north_america_description = /** @type {(inputs: Intro_Region_North_America_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有北美國家都在一個池中。`)
};

/**
* | output |
* | --- |
* | "All North American countries in a single pool." |
*
* @param {Intro_Region_North_America_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_north_america_description = /** @type {((inputs?: Intro_Region_North_America_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_North_America_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_north_america_description(inputs)
	if (locale === "de") return de_intro_region_north_america_description(inputs)
	if (locale === "el") return el_intro_region_north_america_description(inputs)
	if (locale === "en") return en_intro_region_north_america_description(inputs)
	if (locale === "es") return es_intro_region_north_america_description(inputs)
	if (locale === "fr") return fr_intro_region_north_america_description(inputs)
	if (locale === "hi") return hi_intro_region_north_america_description(inputs)
	if (locale === "hu") return hu_intro_region_north_america_description(inputs)
	if (locale === "id") return id_intro_region_north_america_description(inputs)
	if (locale === "it") return it_intro_region_north_america_description(inputs)
	if (locale === "ja") return ja_intro_region_north_america_description(inputs)
	if (locale === "ko") return ko_intro_region_north_america_description(inputs)
	if (locale === "nl") return nl_intro_region_north_america_description(inputs)
	if (locale === "pl") return pl_intro_region_north_america_description(inputs)
	if (locale === "pt") return pt_intro_region_north_america_description(inputs)
	if (locale === "ru") return ru_intro_region_north_america_description(inputs)
	if (locale === "sv") return sv_intro_region_north_america_description(inputs)
	if (locale === "tr") return tr_intro_region_north_america_description(inputs)
	if (locale === "uk") return uk_intro_region_north_america_description(inputs)
	if (locale === "vi") return vi_intro_region_north_america_description(inputs)
	if (locale === "zh") return zh_intro_region_north_america_description(inputs)
	return zh_hant_intro_region_north_america_description(inputs)
});